export const defaultColDef = {
    resizable: true,
    editable: false,
    filter: 'agTextColumnFilter',
    floatingFilter: false,
    suppressAutoSize: true,
}